import React, { useState, useRef, useEffect } from 'react';
import { ChromePicker } from 'react-color';
import { MdOutlineColorize } from 'react-icons/md';

const ColorPicker = ({
  label,
  value,
  onChange,
  showEyeDropper = true,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  const isEyeDropperSupported = typeof window !== 'undefined' && 'EyeDropper' in window;

  // Tıklama dışına ya da Escape tuşuna basıldığında kapat
  useEffect(() => {
    if (!isOpen) return;
    const onClick = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    const onKey = (e) => {
      if (e.key === 'Escape') setIsOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onClick);
      document.removeEventListener('keydown', onKey);
    };
  }, [isOpen]);

  const pickColorFromScreen = async () => {
    if (!isEyeDropperSupported) return;
    try {
      const eyeDropper = new window.EyeDropper();
      const result = await eyeDropper.open();
      onChange(result.sRGBHex);
    } catch {
      // kullanıcı iptal etti
    }
  };

  return (
    <div className="color-setting" ref={containerRef}>
      <div className="color-label">
        <span>{label}</span>
        <div className="color-actions">
          {showEyeDropper && isEyeDropperSupported && (
            <button
              type="button"
              className="eyedropper-button"
              onClick={pickColorFromScreen}
              title="Ekrandan renk seç"
            >
              <MdOutlineColorize size={16} />
            </button>
          )}
          <div
            className="color-preview"
            style={{ '--swatch-color': value }}
            onClick={() => setIsOpen((p) => !p)}
            title={value}
          />
        </div>
      </div>

      {isOpen && (
        <div className="color-picker-container">
          <ChromePicker
            color={value || '#000000'}
            onChange={(color) => {
              const a = color.rgb?.a;
              if (a !== undefined && a < 1) {
                onChange(`rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${a})`);
              } else {
                onChange(color.hex);
              }
            }}
            disableAlpha={false}
          />
        </div>
      )}
    </div>
  );
};

export default ColorPicker;
